module.exports = __webpack_public_path__ + "img/9791160940565.aec496fc.jpg";